module.exports = __webpack_public_path__ + "static/media/refresh.77a49df6.svg";